import * as ActionConfigurationManager from './config.actions';

export const loadStates = ActionConfigurationManager.LOAD_STATES;
export const statesLoaded = ActionConfigurationManager.STATES_LOADED;